import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { EntityLookupActions } from './entity-lookup.action-types';
import { EntityLookupModel } from '@models/entity-lookup.model';

export interface EntityLookupState extends EntityState<EntityLookupModel.EntityLookupDocument> {
  isInitialLoaded: boolean;
}

export const adapter: EntityAdapter<EntityLookupModel.EntityLookupDocument> = createEntityAdapter<EntityLookupModel.EntityLookupDocument>({
  selectId: (entity: EntityLookupModel.EntityLookupDocument) => entity._id,
});

export const { selectAll, selectEntities, selectIds, selectTotal, } = adapter.getSelectors();

const initialState: EntityLookupState = adapter.getInitialState({
  isInitialLoaded: false
});

export const entityLookupReducer = createReducer(
  initialState,

  on(EntityLookupActions.SetEntityLookup, (state, action) => {
    return adapter.addMany(action.payload, {
      ...state,
      isInitialLoaded: true,
    });
  }),
)
